@if (form.allErrors && form.allErrors.length > 0) {
  <div class="rounded border red-theme-border-1 red-theme-bg-1 p-3">
    <p class="flex items-center gap-1 font-semibold red-theme-text-1">
      <mat-icon class="red-theme-text-1">error</mat-icon>
      {{ title }}
    </p>
    <div class="flex flex-col space-y-2 text-sm red-theme-text-1">
      <ul class="space-y-1 list-disc list-inside">
        @for (error of form.allErrors; track $index) {
          <ng-container>
            @if (!error.isNested) {
              <li>
                @if (error.message) {
                  <span class="font-medium">
                    {{ error.message }}
                  </span>
                } @else {
                  <span class="font-medium">{{ error.default_message }}</span>
                }
              </li>
            }
          </ng-container>
        }
        @for (nestedError of nestedErrors(); track $index) {
          <li>
            <span class="font-semibold">
              {{ nestedError.parent_control.split('.')[0] | caseTransform }}
            </span>
            @if (showNestedError) {
              <span class="ml-1">
                {{ nestedError.message || ' - ' + nestedError.default_message }}
              </span>
            } @else {
              <span class="ml-1">
                contains errors, check
                <em class="italic">{{
                  nestedError.parent_control | caseTransform
                }}</em>
                section.
              </span>
            }
          </li>
        }
      </ul>
    </div>
  </div>
}
